"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getApiRootUrl = exports.getLoginUrl = exports.getHovoThemeConfig = exports.getHovoConfig = void 0;
function getHovoConfig() {
    var windowObject = window;
    if (!windowObject.hovoApp) {
        return { apiRootUrl: "" };
    }
    return windowObject.hovoApp;
}
exports.getHovoConfig = getHovoConfig;
function getHovoThemeConfig() {
    var windowObject = window;
    if (!windowObject.hovoThemeVars) {
        return {
            siteRootUrl: "",
            afterLoginRedirectUrl: "",
            afterLoginRedirectTeacherUrl: "",
            loginUrl: "",
            coursePage: "",
            payPage: "",
            waitinglistPage: "",
            registrationSuccessfulPage: ""
        };
    }
    return windowObject.hovoThemeVars;
}
exports.getHovoThemeConfig = getHovoThemeConfig;
function getLoginUrl() {
    return getHovoThemeConfig().loginUrl;
}
exports.getLoginUrl = getLoginUrl;
function getApiRootUrl() {
    return getHovoConfig().apiRootUrl;
}
exports.getApiRootUrl = getApiRootUrl;
